import { $ } from 'utils/dom';
class SetCiColor {
  constructor(props) {
    this.sessionName = 'ci-color';
    this.ciColors = ['green-color', 'blue-color', 'purple-color'];
  }

  checkSession = () => sessionStorage.getItem(this.sessionName);

  setSession = activeCiColor =>
    sessionStorage.setItem(this.sessionName, activeCiColor);

  randomCiColor = () => {
    const activeIndex = Math.floor(Math.random() * this.ciColors.length);
    const activeCiColor = this.ciColors[activeIndex];
    this.setCiColor(activeCiColor);
    this.setSession(activeCiColor);
  };

  setCiColor = activeCiColor => {
    $('body').classList.add(activeCiColor);
  };

  init = () => {
    if (this.checkSession() === null) {
      this.randomCiColor();
    } else {
      const sessionColor = this.checkSession();
      this.setCiColor(sessionColor);
    }
  };
}

new SetCiColor().init();
